module.exports = __webpack_public_path__ + "static/media/dashboard-icon-drivers.38e88c00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard-icon-drivers.svg
// module id = 744
// module chunks = 0